<template>
  <div class="list">
    <section class="main cl">
      <h1>{{ info.title }}</h1>
      <h2 v-if="type==4">应用简介:</h2>
      <section class="con" :class="type==4?'con4':''" v-html="info.content">
      </section>
    </section>
  </div>
</template>

<script>
export default {
  name: "List",
  data() {
    return {
      type: this.$route.params.type,
      info: {}
    };
  },
  methods: {
    getData() {
      this.$api.getAgreement({
        type: this.type
      })
        .then((res) => {
          this.info = res.data.data
        });
    }
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
.main{
  width: 1000px;
  margin: 70px auto;
  background: #fff;
  color: #121212;
  h1{
    border-bottom: 1px solid #EFEFEF;
    line-height: 70px;
    padding: 0 40px;
    text-align: center;
    font-size: 20px;
  }
  h2{
    display: none;
  }
  .con{
    padding: 30px 40px;
    line-height: 2;
    font-size: 16px;
    /deep/ p{
      margin-bottom: 10px;
      font-size: 16px;
      text-align: justify;
    }
  }
}

@media screen and (max-width:640px){
  .header{
    display: none;
  }
  .main{
    width: 100%;
    margin-top: 0;
    h1{
      display: none;
    }
    h2{
      display: block;
      color: #999;
      font-size: 16px;
      line-height: 2;
      padding: 15px 15px 0;
      border-top: 10px solid #F7F7F7;
    }
    .con{
      padding: 15px;
      border-top: 10px solid #F7F7F7;
      &.con4{
        padding-top: 0;
        border-top: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/m/Agreement.vue